/**
 * Shared helpers for Knock notification bell cells.
 * Used by OrderNotificationCell and AiThreadNotificationCell so the cell
 * renderers stay visually consistent (time formatting, AI gradient icon).
 */

/** Renders an icon with the AI gradient fill using an inline SVG linearGradient. */
export function AiGradientIcon({ children, size = 16 }: { children: React.ReactNode; size?: number }) {
  return (
    <span className="relative inline-flex" style={{ width: size, height: size }}>
      <svg width={0} height={0} className="absolute">
        <defs>
          <linearGradient id="ai-icon-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="5%" stopColor="var(--color-ai-from)" />
            <stop offset="100%" stopColor="var(--color-ai-to)" />
          </linearGradient>
        </defs>
      </svg>
      <span className="[&_svg]:fill-[url(#ai-icon-gradient)]">{children}</span>
    </span>
  );
}

/** Compact relative time label, e.g. "just now", "5m ago", "2h ago", "3d ago". */
export function relativeTime(dateStr: string): string {
  const now = Date.now();
  const then = new Date(dateStr).getTime();
  const diffMs = now - then;
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.floor(diffHr / 24);
  return `${diffDay}d ago`;
}
